module.exports = __webpack_public_path__ + "static/media/efset_logo.917b063d.svg";